<script setup lang="ts">
defineOptions({
  name: 'HomePage'
})
</script>

<template>
  <div>
    <Head>
      <Title>Home</Title>
      <Meta
        name="description"
        content="johnsenpartner. architekten bietet Ihnen das gesamte Spektrum der Architektenleistungen. Mit uns werden Ihre Ideen Wirklichkeit."
      />
    </Head>
    <Intro />
    <Referenzen />
    <Prozesse />
  </div>
</template>
